import React from 'react';
import {
    connect
} from 'react-redux';
import {
    actionCreators
} from './store';
import history from 'common/history'
import { WhiteSpace } from 'antd-mobile';
import './index.css'
import Header from 'component/mobile_header'
import InfoBottom from './components/infoBottom'
import InfoImg from './components/infoImg'
import InfoDes from './components/infoDes'
import InfoTab from './components/infoTab'
import AskFor from './components/askFor'
import NoAuth from './components/noAuth'
import userRequest, {
     userApi
 } from 'common/request';
import { getFinishedCourseLock } from './store/actionCreators';
class Courseinfo extends React.Component {
    constructor(props){
        super(props);
        this.state={
            title:'课程详情',
            permission: ''
        }
    }
    async componentDidMount() {
        const { getFinishedCourse, getFinishedCourseLock, getCourseWatched,getCourseInfo, 
          infoList , info, changeCourseInfo,getCourseExcellent,getRecord,user_id} = this.props;
        getCourseWatched(this.props.match.params.id);
        //请求课程内容
        await getCourseInfo(this.props.match.params.id);
        //获取是否收藏
        getRecord(this.props.match.params.id,user_id);
        //获取课程是否已学
        if(localStorage.getItem('userinfo') !== null) {
          let get_user_id = JSON.parse(localStorage.getItem('userinfo')).user_id;
        
          getFinishedCourse(this.props.match.params.id, user_id?user_id: get_user_id);
          getFinishedCourseLock(this.props.match.params.id, JSON.parse(localStorage.getItem('userinfo')).account);
          setTimeout(()=> {this.coursePermission(this.props.match.params.id)},500)
        }
        
    }

    coursePermission = (courseId) => {
        const headers = {
            'Tenant-Id': localStorage.getItem('tenant_code'),
            'Username': JSON.parse(localStorage.getItem('userinfo')).user_name
        }
        userRequest.postRequest(`${window.AppConfig.mainIP}${userApi.coursePermission}/${courseId}`,{},{headers}).then(res => {
            // console.log('--------------------------------------------',res)
            if (res.code != 200) return
            this.setState({permission: res.data})
        })
    }

    recordClick(){
      const {addRecord,delRecord,collect,user_id} =this.props
        if(!collect){
          addRecord(this.props.match.params.id,user_id)
        }else{
          delRecord(this.props.match.params.id,user_id)
        }
    }
    render() {
      const {info,collect, finishedList, finishedListLock, subject, user_id, lastCourseId} =this.props;
      const {permission} = this.state
        return (
            <div>
              <Header title = {this.state.title}/>
              <div className="container info" >
                <InfoImg thumb={info.get('thumb')} data={info.toJS()}/>
                <InfoDes data={info}/>
                <InfoTab permission={permission} />
              </div>
              {permission&&permission.userType!='guest'?<InfoBottom
                  timeInfo = {info}
                  collect={collect}
                  finishedListLock={finishedListLock}
                  finishedList={finishedList}
                  permission={permission}
                  subject={subject}
                  id={this.props.match.params.id}
                  user_id = {user_id}
                  lastCourseId = {lastCourseId}
                  recordClick={()=>{this.recordClick()}}
                />:null}
                {info.toJS().model=='select'&&permission&&permission.userType=='guest'?<AskFor courseId={this.props.match.params.id} info={info.toJS()}></AskFor>:null}
                {info.toJS().model=='require'&&permission&&permission.userType=='guest'?<NoAuth></NoAuth>:null}
            </div>

        )
    }
}


const mapState = (state) => ({
    subject: state.getIn(['courseproject', 'info','subject']),
    infoList: state.getIn(['courseproject', 'infoList']),
    info: state.getIn(['courseproject', 'info']),
    collect:state.getIn(['courseproject', 'collect']),
    user_id: state.getIn(['home','userinfo', 'user_id']),
    finishedList: state.getIn(['courseproject', 'finishedList']),
    finishedListLock: state.getIn(['courseproject', 'finishedListLock']),
    lastCourseId: state.getIn(['courseproject', 'lastCourseId'])
})

const mapDispatch = (dispatch) => ({
    getCourseInfo(course_id) {
        dispatch(actionCreators.getCourseInfo(course_id))
    },
    changeCourseInfo(info){
       dispatch(actionCreators.changeCourseInfo(info))
    },
    getCourseExcellent(course_id){
      dispatch(actionCreators.getCourseExcellent(course_id))
    },
    getRecord(course_id,user_id){
      dispatch(actionCreators.getRecord(course_id,user_id))
    },
    addRecord(course_id,user_id){
      dispatch(actionCreators.addRecord(course_id,user_id))
    },
    delRecord(course_id,user_id){
      dispatch(actionCreators.delRecord(course_id,user_id))
    },
    getCourseWatched(course_id){
        dispatch(actionCreators.getCourseWatched(course_id))
    },
    getFinishedCourse(course_id, user_id){
      dispatch(actionCreators.getFinishedCourse(course_id, user_id))
    },
    getFinishedCourseLock(course_id, user_id){
      dispatch(actionCreators.getFinishedCourseLock(course_id, user_id))
    }
})
export default connect(mapState, mapDispatch)(Courseinfo);
